import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, ExternalLink, Github } from 'lucide-react';

const ProjetCard = ({ projet, index }) => {
  const [currentImage, setCurrentImage] = useState(0);
  
  // Simule plusieurs images pour le carousel
  const images = [
    projet.image,
    projet.image?.replace('.jpg', '-2.jpg'),
    projet.image?.replace('.jpg', '-3.jpg'),
  ].filter(Boolean);

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      viewport={{ once: true }}
      whileHover={{ y: -8 }}
      className="group relative bg-dark-card rounded-2xl overflow-hidden border border-dark-border hover:border-violet-500/50 transition-all duration-500 section-spacing"
    >
      {/* Gradient overlay au survol */}
      <div className={`absolute inset-0 bg-gradient-to-br ${projet.gradient || 'from-violet-600 to-fuchsia-600'} opacity-0 group-hover:opacity-10 transition-opacity duration-500`} />

      {/* Carousel d'images */}
      <div className="relative h-48 overflow-hidden bg-dark-surface">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentImage}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0"
          >
            {images.length > 0 ? (
              <img 
                src={images[currentImage] || '/images/placeholder.jpg'} 
                alt={projet.title}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/400x200/14141F/8B5CF6?text=' + projet.icon;
                }}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-6xl bg-gradient-to-br from-dark-surface to-dark-card">
                {projet.icon}
              </div>
            )}
          </motion.div>
        </AnimatePresence>

        {/* Contrôles du carousel */}
        {images.length > 1 && (
          <>
            {/* <button
              onClick={prevImage}
              className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-violet-600 transition-colors backdrop-blur-sm"
            >
              <ChevronLeft size={16} />
            </button>
            <button
              onClick={nextImage}
              className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-violet-600 transition-colors backdrop-blur-sm"
            >
              <ChevronRight size={16} />
            </button> */}
            
            {/* Indicateurs */}
            {/* <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
              {images.map((_, i) => (
                <button
                  key={i}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImage(i);
                  }}
                  className={`w-1.5 h-1.5 rounded-full transition-all ${
                    i === currentImage ? 'w-4 bg-violet-400' : 'bg-gray-400'
                  }`}
                />
              ))}
            </div> */}
          </>
        )}

        {/* Badge techno principale */}
        <div className="absolute top-2 right-2 bg-dark-surface/80 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-mono border border-violet-500/30">
          {projet.technologies[0]}
        </div>
      </div>

      {/* Contenu */}
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-xl font-bold text-white group-hover:text-violet-400 transition-colors">
            {projet.title}
          </h3>
          <span className="text-2xl">{projet.icon}</span>
        </div>

        <p className="text-gray-400 text-sm mb-4 line-clamp-2">
          {projet.description}
        </p>

        <div className="flex flex-wrap gap-2 mb-4">
          {projet.technologies.slice(0, 3).map((tech, i) => (
            <span 
                key={i} 
                className="px-2 py-1 bg-green-900/20 text-green-300 rounded-full text-xs font-mono border border-green-700/30 hover:bg-green-900/40 transition-colors"
            >
                {tech}
            </span>
            ))}
          {projet.technologies.length > 3 && (
            <span className="px-2 py-1 bg-dark-surface text-gray-400 rounded-full text-xs font-mono border border-dark-border">
              +{projet.technologies.length - 3}
            </span>
          )}
        </div>

        <p className="text-sm text-gray-500 mb-4 font-mono border-l-2 border-violet-500/50 pl-3">
          <span className="text-violet-400">Rôle:</span> {projet.role}
        </p>

        {/* Actions */}
        {/* <div className="flex gap-3 pt-2 border-t border-dark-border">
          <button className="flex items-center gap-1 text-sm text-gray-400 hover:text-violet-400 transition-colors">
            <Github size={16} />
            <span>Code</span>
          </button>
          <button className="flex items-center gap-1 text-sm text-gray-400 hover:text-violet-400 transition-colors">
            <ExternalLink size={16} />
            <span>Démo</span>
          </button>
        </div> */}
      </div>

      {/* Effet de bordure lumineuse */}
      <div className="absolute inset-0 border-2 border-transparent group-hover:border-violet-500/30 rounded-2xl transition-colors duration-500 pointer-events-none" />
    </motion.div>
  );
};

export default ProjetCard;